module.exports = __webpack_public_path__ + "img/left.56952fd8.png";